import { portfolioSelect } from '../queries';
import { useQuery } from 'react-apollo';
import { orderBy } from 'lodash';

export function usePortfolioSelect () {
  const { loading: isLoading, refetch: refresh, data } = useQuery(portfolioSelect, {
    fetchPolicy: 'cache-first'
  });
  const portfolios = orderBy((data?.allPortfolios?.edges ?? []).map(({ node }) => {
    const yearIdentifier = {};
    const isMain = (node.mainPortfolioId === null);
    if (isMain) {
      yearIdentifier[node.year] = node.portfolioId;
    }
    (data?.allPortfolios?.edges ?? []).forEach(pt => {
      if (isMain && (pt.node.mainPortfolioId === node.portfolioId) && pt.node.year) {
        yearIdentifier[pt.node.year] = pt.node.portfolioId;
      }
    });
    return {
      id: node.portfolioId,
      name: node.name,
      year: node.year,
      mainPortfolioId: node.mainPortfolioId,
      isPartnerQueue: node.isPartnerQueue,
      isImpactSnapshot: node.isImpactSnapshot ?? false,
      isMain,
      years: Object.keys(yearIdentifier),
      yearIdentifier,
    };
  }), ['name'],['asc']);

  return { portfolios, refresh, isLoading };
}
